export default __webpack_public_path__ + "static/media/loading.64190053.svg";